import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8bbd1bf4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "kt_header",
  class: "header align-items-stretch"
}
const _hoisted_2 = {
  class: "d-flex align-items-center d-lg-none ms-n3 me-1",
  title: "Show aside menu"
}
const _hoisted_3 = {
  class: "btn btn-icon btn-active-light-secundary",
  id: "kt_aside_mobile_toggle"
}
const _hoisted_4 = { class: "svg-icon svg-icon-2x mt-1 text" }
const _hoisted_5 = { class: "d-flex justify-content-sm-between w-100" }
const _hoisted_6 = {
  class: "d-flex align-items-center flex-grow-sm-1 w-100",
  id: "title",
  style: {"height":"65px"}
}
const _hoisted_7 = { class: "fw-bolder fs-5 cor_texto_1 text-truncate text-concessionaria" }
const _hoisted_8 = {
  key: 1,
  class: "fw-bolder fs-5 cor_texto_1 text-truncate text-concessionaria"
}
const _hoisted_9 = {
  class: "d-flex align-items-center justify-content-end g-4",
  id: "kt_header_menu_nav"
}
const _hoisted_10 = {
  key: 1,
  class: "btn-WhatsApp"
}
const _hoisted_11 = ["fill"]
const _hoisted_12 = ["fill"]
const _hoisted_13 = {
  key: 2,
  class: "py-0"
}
const _hoisted_14 = {
  class: "btn btn-sm btn-icon background_btn_1_opct",
  id: "kt_header_menu_mobile_toggle",
  style: {"height":"40px","width":"40px"}
}
const _hoisted_15 = { class: "svg-icon svg-icon-1 cor_btn_1" }
const _hoisted_16 = {
  key: 3,
  class: "d-none d-md-flex flex-column align-items-end ps-3"
}
const _hoisted_17 = { style: {"white-space":"nowrap","font-weight":"500","font-size":"16px","color":"var(--el-color-primary)","margin-right":"8px"} }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-pencil-alt",
  "aria-hidden": "true",
  style: {"margin":"0","padding":"0","font-size":"16px"}
}, null, -1))
const _hoisted_19 = { style: {"white-space":"nowrap","font-size":"13px","color":"var(--cor_texto_1)"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_KTMenu = _resolveComponent("KTMenu")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass([{
        'container-fluid': _ctx.headerWidthFluid,
        'container-xxl': !_ctx.headerWidthFluid,
      }, "d-flex align-items-stretch justify-content-between"])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, [
            _createVNode(_component_inline_svg, { src: "./media/icons/duotune/abstract/abs015.svg" })
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          (_ctx.isMobile)
            ? (_openBlock(), _createBlock(_component_el_tooltip, {
                key: 0,
                class: "item",
                effect: "dark",
                placement: "bottom"
              }, {
                content: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.headerTitle), 1)
                ]),
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.headerTitle), 1)
                ]),
                _: 1
              }))
            : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.headerTitle), 1))
        ]),
        _createElementVNode("div", _hoisted_9, [
          (_ctx.showMenu2)
            ? (_openBlock(), _createBlock(_component_KTMenu, { key: 0 }))
            : _createCommentVNode("", true),
          ( +_ctx.userRoleLevel < 200)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("button", {
                  class: "btn-WhatsApp",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goToWhatsapp && _ctx.goToWhatsapp(...args)))
                }, [
                  (_openBlock(), _createElementBlock("svg", {
                    width: "20",
                    height: "20",
                    viewBox: "0 0 20 20",
                    fill: _ctx.isConnected ? 'green' : 'red',
                    xmlns: "http://www.w3.org/2000/svg",
                    class: "me-3"
                  }, [
                    _createElementVNode("path", {
                      d: "M16.1289 3.79297C14.4922 2.15234 12.3125 1.25 9.99609 1.25C5.21484 1.25 1.32422 5.14062 1.32422 9.92188C1.32422 11.4492 1.72266 12.9414 2.48047 14.2578L1.25 18.75L5.84766 17.543C7.11328 18.2344 8.53906 18.5977 9.99219 18.5977H9.99609C14.7734 18.5977 18.75 14.707 18.75 9.92578C18.75 7.60938 17.7656 5.43359 16.1289 3.79297ZM9.99609 17.1367C8.69922 17.1367 7.42969 16.7891 6.32422 16.1328L6.0625 15.9766L3.33594 16.6914L4.0625 14.0313L3.89062 13.7578C3.16797 12.6094 2.78906 11.2852 2.78906 9.92188C2.78906 5.94922 6.02344 2.71484 10 2.71484C11.9258 2.71484 13.7344 3.46484 15.0937 4.82812C16.4531 6.19141 17.2891 8 17.2852 9.92578C17.2852 13.9023 13.9687 17.1367 9.99609 17.1367ZM13.9492 11.7383C13.7344 11.6289 12.668 11.1055 12.4688 11.0352C12.2695 10.9609 12.125 10.9258 11.9805 11.1445C11.8359 11.3633 11.4219 11.8477 11.293 11.9961C11.168 12.1406 11.0391 12.1602 10.8242 12.0508C9.55078 11.4141 8.71484 10.9141 7.875 9.47266C7.65234 9.08984 8.09766 9.11719 8.51172 8.28906C8.58203 8.14453 8.54687 8.01953 8.49219 7.91016C8.4375 7.80078 8.00391 6.73438 7.82422 6.30078C7.64844 5.87891 7.46875 5.9375 7.33594 5.92969C7.21094 5.92188 7.06641 5.92188 6.92187 5.92188C6.77734 5.92188 6.54297 5.97656 6.34375 6.19141C6.14453 6.41016 5.58594 6.93359 5.58594 8C5.58594 9.06641 6.36328 10.0977 6.46875 10.2422C6.57813 10.3867 7.99609 12.5742 10.1719 13.5156C11.5469 14.1094 12.0859 14.1602 12.7734 14.0586C13.1914 13.9961 14.0547 13.5352 14.2344 13.0273C14.4141 12.5195 14.4141 12.0859 14.3594 11.9961C14.3086 11.8984 14.1641 11.8438 13.9492 11.7383Z",
                      fill: _ctx.isConnected ? 'green' : 'red'
                    }, null, 8, _hoisted_12)
                  ], 8, _hoisted_11)),
                  _createTextVNode(" " + _toDisplayString(_ctx.isConnected ? 'Conectado' : 'Desconectado'), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_router_view, {
            name: "filter",
            class: "me-3"
          }),
          _createVNode(_component_router_view, {
            name: "export",
            class: "me-3"
          }),
          (_ctx.showMenu2)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("span", _hoisted_15, [
                    _createVNode(_component_inline_svg, { src: "./media/icons/duotune/text/txt001.svg" })
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (+_ctx.userRoleLevel < 600)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _createVNode(_component_router_link, {
                  to: `/perfil`,
                  class: "btn-edit-user d-flex align-items-center"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.userName), 1),
                    _hoisted_18
                  ]),
                  _: 1
                }),
                _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.userRoleDesc), 1)
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ], 2)
  ]))
}